export default "__VITE_ASSET__D4TD2UaZ__"